module.exports = __webpack_public_path__ + "static/media/documentor.d0745ad9.png";